var _a, _b, _c;
import { __decorate, __metadata } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { RouterService } from '@workspace/shared/services/vue-router-service';
import { SpaceRouteName, SpaceType } from '../enums';
import { SpaceSortTypeService } from './space-sort-type-service.interface';
import { SpaceLabelService } from './space-label-service.interface';
let SpaceQueryServiceImpl = class SpaceQueryServiceImpl {
    setSpaceQuery(query) {
        this._spaceSortTypeService.setSpaceSortType(query.sortBy);
        this._spaceLabelService.setSpaceLabel(query.labelName);
    }
    get _currentRoute() {
        return this._routerService.currentRoute;
    }
    getSpaceQuery() {
        const spaceQuery = {
            sortBy: this._spaceSortTypeService.getSpaceSortType(),
            labelName: this._spaceLabelService.getSpaceLabel(),
            spaceType: this._currentRoute.name === SpaceRouteName.Personal
                ? SpaceType.Personal : this._currentRoute.name === SpaceRouteName.Shared
                ? SpaceType.Shared : this._currentRoute.name === SpaceRouteName.Public
                ? SpaceType.Public : SpaceType.All,
        };
        return spaceQuery;
    }
};
__decorate([
    inject(RouterService),
    __metadata("design:type", typeof (_a = typeof RouterService !== "undefined" && RouterService) === "function" ? _a : Object)
], SpaceQueryServiceImpl.prototype, "_routerService", void 0);
__decorate([
    inject(SpaceSortTypeService),
    __metadata("design:type", typeof (_b = typeof SpaceSortTypeService !== "undefined" && SpaceSortTypeService) === "function" ? _b : Object)
], SpaceQueryServiceImpl.prototype, "_spaceSortTypeService", void 0);
__decorate([
    inject(SpaceLabelService),
    __metadata("design:type", typeof (_c = typeof SpaceLabelService !== "undefined" && SpaceLabelService) === "function" ? _c : Object)
], SpaceQueryServiceImpl.prototype, "_spaceLabelService", void 0);
SpaceQueryServiceImpl = __decorate([
    injectable()
], SpaceQueryServiceImpl);
export { SpaceQueryServiceImpl };
